module.exports = __webpack_public_path__ + "static/media/cor.6de116f9.jpeg";